(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-capture"]) return;
  try {
    
  (() => {
    const card = document.querySelector('[data-ecap]');
    if (!card) return;

    const KEY = 'ss-ecap';
    const days = parseInt(card.dataset.days, 10) || 30;
    const now = Date.now();

    const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
    const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} };

    const state = read();
    /* The Liquid form object only exists inside the form tag, so the success
       state is read back out of the DOM rather than from a data attribute on
       the wrapper, which would always have been false. */
    const posted = !!card.querySelector('[data-ecap-done]');
    const openNow = posted;

    if (!openNow) {
      if (state.subscribed) { card.remove(); return; }
      if (state.closedAt && now - state.closedAt < days * 86400000) { card.remove(); return; }
    }

    let opened = false;
    let lastFocus = null;

    const open = () => {
      if (opened) return;
      opened = true;
      card.hidden = false;
      lastFocus = document.activeElement;
      requestAnimationFrame(() => card.classList.add('is-open'));
      document.body.classList.add('has-ecap');
      const field = card.querySelector('input[type="email"]');
      /* Focus the field only when the visitor asked for this by scrolling to
         the end; grabbing the caret mid-read is hostile. */
      if (openNow && field) field.focus();
      document.addEventListener('keydown', onKey);
      cleanup();
    };

    const close = (remember) => {
      card.classList.remove('is-open');
      document.body.classList.remove('has-ecap');
      document.removeEventListener('keydown', onKey);
      if (remember) write(Object.assign(read(), { closedAt: Date.now() }));
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      setTimeout(() => { card.hidden = true; }, 400);
    };

    const onKey = (e) => { if (e.key === 'Escape') close(true); };

    const onScroll = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      const pct = (window.scrollY / max) * 100;
      if (pct >= (parseInt(card.dataset.scroll, 10) || 45)) open();
    };
    const onLeave = (e) => { if (e.clientY <= 0) open(); };

    function cleanup() {
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseleave', onLeave);
      clearTimeout(timer);
    }

    const timer = setTimeout(open, parseInt(card.dataset.delay, 10) || 30000);
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseleave', onLeave);

    card.querySelector('[data-ecap-close]')?.addEventListener('click', () => close(true));
    card.querySelector('form')?.addEventListener('submit', () => {
      write(Object.assign(read(), { subscribed: true }));
    });

    if (openNow) {
      write(Object.assign(read(), { subscribed: true }));
      open();
      setTimeout(() => close(false), 6000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visit-bar"]) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-visit-bar]');
    if (!bar) return;
    const KEY = 'ss-visitbar-closed';
    let closed = false;
    try { closed = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (closed) { bar.remove(); return; }

    bar.hidden = false;
    const show = () => {
      if (window.scrollY > window.innerHeight * 0.9) {
        bar.classList.add('is-up');
      } else {
        bar.classList.remove('is-up');
      }
    };
    show();
    window.addEventListener('scroll', show, { passive: true });

    bar.querySelector('[data-visit-close]')?.addEventListener('click', () => {
      bar.classList.remove('is-up');
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      setTimeout(() => bar.remove(), 400);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
